<template>
  <v-container full-width>
    <v-layout
      id="signature-corequester-container"
      align-center
      justify-center
      column
      fill-height
    >
      <div>
        <h1 class="display-3 font-weight-bold text-center">
          Signature de documents
        </h1>
        <div class="mt-4" v-if="signature">
          Bonjour {{ coRequesterFullName }},<br />
          Vous êtes enregistré comme co-demandeur d'une demande de
          relocalisation émise par {{ requesterFullName }}.<br />
          Pour finaliser celle-ci, vous devez procéder à la signature des
          documents ci-dessous : <br />
        </div>
      </div>
    </v-layout>

    <v-layout id="signature-iframe-container">
      <iframe
        :src="documentUrl"
        title="Signer le document"
        width="100%"
        height="700px"
        v-if="documentUrl"
      ></iframe>
    </v-layout>

    <v-snackbar v-model="showError" :timeout="7000"
      >Une erreur a eu lieu</v-snackbar
    >
  </v-container>
</template>

<script>
import { fetchHil } from "../utils";

export default {
  components: {},
  data() {
    return {
      projectId: null,
      transactionId: null,
      signatoryId: null,
      showError: false,
      transaction: {},
      documentUrl: null,
      signature: null
    };
  },
  async mounted() {
    this.loadData();
  },
  computed: {
    requesterFullName() {
      return `${this.$store.state.currentProject.firstName} ${
        this.$store.state.currentProject.lastName
      }`;
    },
    coRequesterFullName() {
      return `${this.$store.state.currentProject.coFirstName} ${
        this.$store.state.currentProject.coLastName
      }`;
    }
  },
  methods: {
    async loadData() {
      const decodedParam = atob(this.$route.params.encodedParam);
      const [leaseId, transactionId, signatoryId] = decodedParam.split("_");

      // Assign the collected values
      this.projectId = leaseId;
      this.transactionId = transactionId;
      this.signatoryId = signatoryId;

      // Fetch the details of the project
      await this.$store.dispatch("fetchProjectForPublicSignature", {
        id: this.projectId
      });

      // Get the current signature
      this.signature =
        this.$store.state.currentProject &&
        this.$store.state.currentProject.signatures
          ? this.$store.state.currentProject.signatures.find(
              signature => signature.transactionId === this.transactionId
            )
          : null;

      // Generate the signature URL
      if (this.signature) {
        let resp;
        try {
          resp = await fetchHil(
            `/signatures/${this.projectId}/${this.transactionId}/${
              this.signatoryId
            }`,
            { method: "GET" }
          );
        } catch (e) {
          console.log(e);
        }

        if (!resp || !resp.ok) {
          this.showError = true;
          return;
        }

        const result = await resp.json();

        if (result.url) {
          this.documentUrl = result.url;
        }
      }
    }
  }
};
</script>

<style scoped>
.text-center {
  text-align: center;
}
.error,
.success {
  color: white;
  font-weight: bold;
  padding: 10px;
}
.container.full-width {
  width: 100%;
  max-width: 100%;
}
#signature-corequester-container {
  max-width: 700px;
  margin: 0 auto;
}
#signature-iframe-container {
  width: 90%;
  margin: 40px auto 0 auto;
}
</style>
